export const ALL_OPTION = { id: -1, title: 'ALL' };
export const NONE_OPTION = { id: 0, title: 'NONE' };
